import React, { useState } from 'react';
import {
    Box,
    Typography,
    TextField,
    Button,
    IconButton,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

const CheckUserBalance = () => {
    const navigate = useNavigate();
    const [username, setUsername] = useState('');
    const [whatsappBalance, setWhatsappBalance] = useState('');
    const [whatsappButtonBalance, setWhatsappButtonBalance] = useState('');
    const [apiBalance, setApiBalance] = useState('');
    const [error, setError] = useState(null);

    const handleClose = () => {
        navigate('/users');
    };

    const handleUpdate = async () => {
        try {
            const response = await axios.post(
                'https://d3ioa5kdb9.execute-api.ap-south-1.amazonaws.com/Tis_whatsapp_be/balance_check',
                { username }
            );

            const item = response.data["body-json"]?.body?.Item;
            if (item) {
                // Set all fields editable with fetched data
                setWhatsappBalance(item.whatsapp_balance ?? '');
                setWhatsappButtonBalance(item.whatsapp_button_balance ?? '');
                setApiBalance(item.api_balance ?? '');
                setError(null);
            } else {
                setWhatsappBalance('');
                setWhatsappButtonBalance('');
                setApiBalance('');
                setError("No balance data found.");
            }
        } catch (err) {
            console.error("API Error:", err);
            setWhatsappBalance('');
            setWhatsappButtonBalance('');
            setApiBalance('');
            setError('Failed to fetch balance. Please try again.');
        }
    };

    return (
        <Box
            sx={{
                width: 400,
                mx: 'auto',
                mt: 4,
                p: 3,
                borderRadius: 2,
                boxShadow: 1,
                backgroundColor: '#fff',
                position: 'relative',
                bgcolor: "#fafafa"
            }}
        >
            <IconButton
                onClick={handleClose}
                sx={{
                    position: 'absolute',
                    top: 8,
                    right: 8,
                    color: 'gray',
                }}
            >
                <CloseIcon />
            </IconButton>

            <Typography
                variant="subtitle1"
                sx={{ fontWeight: 'bold', mb: 2, color: '#1a237e' }}
            >
                Check User Balance
            </Typography>

            {/* Username input (editable) */}
            <Typography variant="body2" sx={{ mb: 0.5 }}>
                Username :
            </Typography>
            <TextField
                fullWidth
                placeholder="username"
                size="small"
                variant="outlined"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                sx={{ mb: 2 }}
            />

            {/* Whatsapp Balance (editable) */}
            <Typography variant="body2" sx={{ mb: 0.5 }}>
                Whatsapp Balance :
            </Typography>
            <TextField
                fullWidth
                value={whatsappBalance}
                placeholder="Whatsapp balance"
                size="small"
                variant="outlined"
                onChange={(e) => setWhatsappBalance(e.target.value)}
                sx={{ mb: 2 }}
            />

            {/* Whatsapp Button Balance (editable) */}
            <Typography variant="body2" sx={{ mb: 0.5 }}>
                Whatsapp Button Balance :
            </Typography>
            <TextField
                fullWidth
                value={whatsappButtonBalance}
                placeholder="Whatsapp button balance"
                size="small"
                variant="outlined"
                onChange={(e) => setWhatsappButtonBalance(e.target.value)}
                sx={{ mb: 2 }}
            />

            {/* API Balance (editable) */}
            <Typography variant="body2" sx={{ mb: 0.5 }}>
                Api Balance :
            </Typography>
            <TextField
                fullWidth
                value={apiBalance}
                placeholder="API balance"
                size="small"
                variant="outlined"
                onChange={(e) => setApiBalance(e.target.value)}
                sx={{ mb: 3 }}
            />

            {error && (
                <Typography color="error" sx={{ mb: 2 }}>
                    {error}
                </Typography>
            )}

            <Button
                variant="contained"
                onClick={handleUpdate}
                sx={{
                    background: 'linear-gradient(to right, #0052D4, #4364F7, #6FB1FC)',
                    color: '#fff',
                    textTransform: 'none',
                    fontWeight: 'bold',
                    borderRadius: 2,
                    py: 1,
                    fontSize: '1rem',
                    boxShadow: '0 4px 12px rgba(0, 82, 212, 0.4)',
                    transition: 'all 0.3s ease',
                    '&:hover': {
                        transform: 'scale(1.03)',
                        boxShadow: '0 6px 16px rgba(67, 100, 247, 0.5)',
                        background: 'linear-gradient(to right, #003cbd, #3451e0, #5e96f5)',
                    },
                }}
            >+
                🚀 Update
            </Button>
        </Box>
    );
};

export default CheckUserBalance;
